module.exports = __webpack_public_path__ + "img/bell.95ceec92.svg";